// react
import React, { useState } from "react";
// form
import { useForm } from 'react-hook-form';
import { PhotoLogin } from "../../../../services/photographer/auth/photoLogin.tsx";
// react query
import { useMutation } from "@tanstack/react-query";
// toast
import { toastOptions } from "../../../../features/toast/toast.tsx";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// @ts-ignore
import Cookies from "js-cookie";
// error
import { onError } from "../../../../features/error/error.tsx";
// icons
import { IconEye, IconEyeOff } from "@tabler/icons-react";

const Photograph = () => {
    const { register, handleSubmit }: any = useForm<any>();
    const [showPass, setShowPass] = useState<boolean>(false);
    const mutation = useMutation({
        mutationFn: PhotoLogin,
        onSuccess: data => {
            toast.success('با موفقیت وارد شدید', toastOptions);
            Cookies.set('photographer_token', data.token);
            localStorage.setItem('username', data.user.full_name)
            window.open('/photographer/panel', "_self")
        },
        onError: () => {
            toast.error('رمز عبور یا نام کاربری اشتباه است', toastOptions);
        },
    });
    const onSubmit = (data: any) => {
        mutation.mutate(data)
    };
    return (
        <>
            <section className='modal fade' id='photograph'>
                <div className='modal-dialog modal-dialog-centered'>
                    <div className='modal-content rounded rounded-4'>
                        <div className='modal-body'>
                            <div className='text-center w-100'>
                                <img alt='logo' className='logo' src={require('./../../../../assets/media/logo/logo.png')} />
                            </div>
                            <div className="content p-4 pt-1">
                                <div className="texts text-center">
                                    <p className="h3 fw-bold text-center">ورود و ثبت نام</p>
                                    <p className="text mt-3 text-center">سلام، عکاس عزیز خوش اومدی :) </p>
                                </div>
                                <form onSubmit={handleSubmit(onSubmit, onError)}>
                                    <fieldset className='form-floating mt-2'>
                                        <input
                                            type='text'
                                            placeholder='نام کاربری'
                                            className='form-control'
                                            {...register('username', { required: 'فیلد نام کاربری الزامی است' })}
                                        />
                                        <label className='form-label'>
                                            نام کاربری
                                        </label>
                                    </fieldset>
                                    <fieldset className='form-floating my-4 mb-2 position-relative'>
                                        <input
                                            type={showPass ? 'text' : 'password'}
                                            placeholder='رمز عبور'
                                            className='form-control'
                                            {...register('password', { required: 'فیلد رمز عبور الزامی است' })}
                                        />
                                        <label className='form-label'>
                                            رمز عبور
                                        </label>
                                        {showPass ? <IconEyeOff color={'#757575'} onClick={() => setShowPass(false)} className="position-absolute eye-icon" /> : <IconEye color={'#757575'} onClick={() => setShowPass(true)} className="position-absolute eye-icon" />}
                                    </fieldset>
                                    <div className="d-flex">
                                        <button disabled={mutation.isPending} className='btn btn-outline-primary w-100 mt-2'>
                                            {mutation.isPending ? 'در حال ارسال...' : 'ورود'}
                                        </button>
                                        <button type="button" data-bs-toggle="modal" data-bs-target="#cv" className='btn btn-primary-site w-100 mt-2 ms-2'>
                                            ثبت نام
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default Photograph;